import { contentApi } from '../index';
import { apiRoutes } from '../apiRoutes';
import { CountryData } from './types';

export const getCountries = async () => {
  const response = await contentApi.get<CountryData>(apiRoutes.country._);
  return response?.data;
};
